import styled from 'styled-components'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { Box } from '../../../Common/Box'

import { themeColor } from '../../../Common/Theme/utils'
import { Card } from '../../../Common/Card'
import { Link } from 'react-router-dom'
import { Flex } from '../../../Common/Flex'

export const CardNameContainer = styled.div`
  display: flex;
`

export const EditIcon = styled(FontAwesomeIcon)`
  width: 16px;
  font-size: 0.8em;
  height: 16px;
  margin: 0 8px;
  color: #616060;
  &:hover {
    cursor: pointer;
    color: #2164db;
  }
`
export const IconWrapper = styled.div`
  position: relative;
`

export const OutOfServiceIcon = styled(FontAwesomeIcon)`
  font-size: 1.15em;
  margin-right: 6px;
  color: #7f839b;
  justify-content: center;
  align-items: center;
  padding-bottom: 2px;
  &:hover {
    cursor: pointer;
    color: #2164db;
  }
`

export const OutOfServiceToolTip = styled.div`
  width: 260px;
  height: 60px;
  background-color: #474747;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 10px 0;
  position: absolute;
  z-index: 1;
  left: 124%;
  top: 5%;

  ::after {
    content: '';
    position: absolute;
    top: 20%;
    right: 100%;
    margin-top: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: transparent #474747 transparent transparent;
  }
`

export const ToolTipText = styled.span`
  padding: 0 4px;
  font-size: 0.75em;
  align-items: center;
  justify-content: center;
`

export const StyledBox = styled(Box)`
  border-radius: 100%;
  cursor: pointer;
`

export const StyledImage = styled.img`
  border-radius: 50%;
`

export const StyledCard = styled(Card)`
  width: 100%;
  min-width: 23em;
`

export const StyledFlex = styled(Flex)`
  width: 100%;

  @media(min-width: 1200px) {
    width: calc(50% - 8px);

    &:nth-child(odd) {
      margin-right: 16px;
    }
  }
`

export const StyledPunchClockBox = styled(Box)<{
  hasOpenPunchclockTime: boolean
}>`
  border-radius: 50%;
  cursor: pointer;
  font-weight: bold;
  display: none;
  background: ${({ hasOpenPunchclockTime, theme }) =>
    hasOpenPunchclockTime
      ? themeColor('destructive', theme)
      : themeColor('success', theme)};
`

export const ContainerBox = styled(Box)`
  font-size: 0.9em;
`

export const BoxContainer = styled(Box)`
  justify-content: space-between;
`

export const NameBox = styled(Box)`
  font-size: 1.1em;
  margin-bottom: 0.5em;
  text-overflow: ellipsis;
  max-width: 106px;
`

export const ActionIcon = styled(FontAwesomeIcon)`
  color: #7f839b;
  font-size: 1em;
  margin-right: 6px;
  &:hover {
    cursor: pointer;
    color: #2164db;
  }
`

export const BoxLabel = styled(Box)`
  font-size: 0.9em;
`

export const StyledLink = styled(Link)`
  color: #7f849d;
`
export const StyledText = styled.p`
  margin: 0;
`